import type { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when the retailer dismisses the Last Chance First Order Incentive modal
 */
export const LAST_CHANCE_FIRST_ORDER_INCENTIVE_MODAL_DISMISS =
  'LAST_CHANCE_FIRST_ORDER_INCENTIVE_MODAL_DISMISS' as IUserMilestone.RetailerMilestone;
